import { INCUMBENT_TYPES } from '~constants/incumbent';

export const getGuarantorShareLink = (quickCode, kind) =>
  `${process.env.REACT_APP_URL}/simulations/steps/continue/${kind}/${quickCode}?view=${INCUMBENT_TYPES.GUARANTOR}`;
